module.exports = __webpack_public_path__ + "img/FacecopeB_2.55648450.png";